import React, { Component } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 0.5rem;
  margin-bottom: 2rem;
  background-color: ${p => p.theme.color.white10};
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media screen and (max-width: 400px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 0.5rem;
  }

  justify-content: space-between;
  padding: 0.5rem;
`;

class Panel extends Component {

  render() {
    const { data } = this.props;

    return data ? (
      <Container>
        <Row>
          <div>ID</div>
          <div>{ data._id }</div>
        </Row>
        <Row>
          <div>Timestamp</div>
          <div>{ data.timestamp }</div>
        </Row>
        <Row>
          <div>Name</div>
          <div>{ data.name }</div>
        </Row>
        <Row>
          <div>Email</div>
          <div>{ data.email }</div>
        </Row>
        <Row>
          <div>Roles</div>
          <div>{data.roles && data.roles.join(', ')}</div>
        </Row>
        <Row>
          <div>Application:</div>
        </Row>
        <Row>
          <div>{data.message.split('\n').map((item, key) => {
            return <span key={key}>{item}<br/></span>
          })}</div>
        </Row>

      </Container>
    ) : null;
  }
}

export default Panel;